import { UserStatus } from "../components/routes/routing_statuses/RoutingStatuses";
import { db } from "../firebase-config";
import { doc, onSnapshot } from "firebase/firestore";

export const subscriptionSnapshotListener = (stripeCustomerId, onSubscriptionUpdate) => {
    const docRef = doc(db, "stripe_customers", stripeCustomerId);

    const unsubscribe = onSnapshot(docRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
            const subscriptionData = { id: docSnapshot.id, ...docSnapshot.data() };
            onSubscriptionUpdate(subscriptionData);
        } else {
            onSubscriptionUpdate(UserStatus.DOES_NOT_EXIST);
        }
    });

    return () => unsubscribe();
};